/* IP and location gathering function
extract info from provided attributes and inject to appropriate input fields to send info to backend */

var buttonsDisabled = false;

function initUserConsFunc() {
    setTimeout(() => {
        const userConsent = document.querySelectorAll(".sk-marketingChannels");
        let userConsentInput;
        const userIp = document.querySelectorAll(".sk-userIP input");
        const userLocation = document.querySelectorAll(".sk-userLocation input");
        
        //Checking if the input attributes are present on the page
        if(!userConsent.length === 0 || userIp.length === 0 || userLocation.length === 0) {
            //console.log("Attributes are not present", userConsent, userIp, userLocation);
            return;
        } else {
            document.addEventListener("processUpdated.skye", () => {
                userConsent.forEach((input) => {
                    if(input.getAttribute("data-component-type") == "RADIO") {
                        userConsentInput = input.querySelector("label");
                        if(userConsentInput.classList.contains("sk-selected") && userIp[0].value == "") {
                            getUserInfo();
                        }else {
                            return;
                        }
                    } else if (input.getAttribute("data-component-type") == "CHECKBOX") {
                        userConsentInput = input.querySelector("input");
                        if(userConsentInput.checked && userIp[0].value == "") {
                            getUserInfo();
                        } else {
                            return;
                        }
                    }
                })
            })   
        }
    }, 500)
}

// https://ipv4.geojs.io/v1/ip/geo.json
// https://get.geojs.io/v1/ip/geo.json
function getUserInfo() {
    handleActionButtons();
    fetch("https://get.geojs.io/v1/ip/geo.json").then(res => res.text()).then(data => {
            userConsentFunc(JSON.parse(data));
        }).catch(error => {
            console.log(`Error getting user info: ${error}`);
        })
}

async function userConsentFunc(userData) {
    //console.log(userData);
    const userIpValue = userData.ip;
    const userLocationValue = `${userData.city}/${userData.country}`;

    await fillInputsSequentially(".sk-userIP input", userIpValue);
    await fillInputsSequentially(".sk-userLocation input", userLocationValue);
    handleActionButtons();
}

async function fillInputAndAwaitUpdate(input, value) {
    return new Promise((resolve, reject) => {

        // //Function to call when processUpdated event is fired
        // const onProcessUpdated = () => {
        //     document.removeEventListener("processUpdated.skye", onProcessUpdated);
        //     resolve();
        // }

        // //Listen for the processUpdated event
        // document.addEventListener("processUpdated.skye", onProcessUpdated);

        //Set the input value and dispatch as needed
        input.focus();
        input.value = value;
        input.dispatchEvent(new Event("input", { bubbles: true })); // for React's synthetic events
        input.blur();
        resolve();
    });
}

async function fillInputsSequentially(className, value) {
    const inputs = document.querySelectorAll(className);
    for(const input of inputs) {
        try {
            await fillInputAndAwaitUpdate(input, value);
        } catch (error) {
            console.error(`Error when processing input for class: ${className}`, error);
        }
    }
}

async function handleActionButtons() {
    document.querySelectorAll('.sk-button').forEach(btn => {
        btn.disabled = !btn.disabled;
    });
    buttonsDisabled = !buttonsDisabled;
    //console.log(`buttons are disabled: ${buttonsDisabled}` )
}

export { initUserConsFunc }